import createHTMLMediaHook from './factory/createHTMLMediaHook';
var useVideo = createHTMLMediaHook('video');
export default useVideo;
